const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Eftpos24 = function Eftpos24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M12.8106 3.48182C10.6679 4.46039 9.21906 6.33396 9.21906 8.4852C9.21906 11.1999 11.7196 13.4008 14.804 13.4008C16.2196 13.4008 17.2151 13.0738 18.379 12.3737C18.5026 12.2997 18.642 12.2439 18.7333 12.3598C18.7856 12.4261 18.7637 12.5065 18.7236 12.5801C17.4524 14.9123 14.8656 16.534 11.9626 16.534C7.67322 16.534 4.19604 13.0569 4.19604 8.76749C4.19604 6.31817 5.32982 4.13382 7.10133 2.71006C8.43228 1.6406 11.7677 1.4931 12.8106 3.48182Z",
      fill: "url(#paint0_linear_22854_208)",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M18.6341 6.489C18.6341 9.06887 16.1702 11.16 13.1309 11.16C12.6888 11.16 11.4911 11.0992 10.6342 10.7002C10.3904 10.5866 10.4155 10.4441 10.583 10.3748C10.9723 10.2142 14.0266 9.62805 14.0266 6.48862C14.0266 3.34918 10.7852 1.05392 7.10156 2.70913C8.43212 1.63967 10.1228 1 11.9628 1C15.5698 1.00077 18.6341 3.45779 18.6341 6.489Z",
      fill: "#E50056",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M2.93942 18.5508C1.67626 18.5508 1 19.311 1 20.2946V20.3227C1 21.312 1.53646 21.9606 2.88358 21.9606C3.85599 21.9606 4.5103 21.6475 4.7895 20.9096H3.8506C3.7108 21.1499 3.44816 21.2843 2.9452 21.2843C2.25778 21.2843 1.91657 21.0328 1.82722 20.5745H4.83456V20.2337C4.83456 19.2605 4.18026 18.5508 2.93942 18.5508ZM1.83839 19.9372C1.95007 19.4843 2.31901 19.2216 2.95637 19.2216C3.57678 19.2216 3.89527 19.4508 3.97923 19.9372H1.83839Z",
      fill: "#1F0038",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M8.63057 17.779H7.90387C7.90387 17.9242 7.89847 18.1591 7.87036 18.3101C7.81991 18.5785 7.7529 18.6351 7.51259 18.6575C7.36163 18.6686 7.1941 18.6686 7.03197 18.6686H6.46201V18.5338C6.46201 18.0474 6.55713 17.9581 6.98191 17.9581H7.26342V17.2649H6.88678C5.95905 17.2649 5.64018 17.578 5.64018 18.5003V18.6686H4.88574V19.3946H5.64018V21.8651H6.45623L6.46162 19.3946H7.81413V20.4009C7.81413 21.4907 8.10489 21.8654 9.17242 21.8654H9.78167V21.0998H9.39579C8.73609 21.0998 8.63019 21.0047 8.63019 20.2615V19.3949H9.78167V18.669H8.63019V17.779H8.63057Z",
      fill: "#1F0038",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M12.3355 18.562C11.7093 18.562 11.2287 18.8193 10.9826 19.2606L10.9114 18.6687H10.1777V23H11.0219V21.3568C11.251 21.7369 11.6704 21.9491 12.3132 21.9491C13.2186 21.9491 13.9676 21.4014 13.9676 20.3V20.2719C13.9676 19.1601 13.3418 18.562 12.3355 18.562ZM13.09 20.295C13.09 20.9043 12.7715 21.2397 12.0448 21.2397C11.3573 21.2397 11.005 20.8989 11.005 20.2896V20.2673C11.005 19.6357 11.402 19.261 12.0559 19.261C12.7434 19.261 13.09 19.6076 13.09 20.2727V20.295Z",
      fill: "#1F0038",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M16.2205 18.5508C15.0748 18.5508 14.2976 19.1935 14.2976 20.2668V20.3003C14.2976 21.3455 14.8733 21.9606 16.2035 21.9606C17.4948 21.9606 18.1487 21.3178 18.1487 20.3003V20.2668C18.1487 19.1824 17.3885 18.5508 16.2205 18.5508ZM17.2711 20.295C17.2711 20.9042 16.9526 21.2396 16.2201 21.2396C15.5157 21.2396 15.1749 20.91 15.1749 20.295V20.2668C15.1749 19.6071 15.555 19.2605 16.2313 19.2605C16.9245 19.2605 17.2711 19.6183 17.2711 20.2668V20.295Z",
      fill: "#1F0038",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M20.3744 19.9092C19.5414 19.8533 19.3122 19.7975 19.3122 19.5626C19.3122 19.3669 19.4744 19.1994 20.0724 19.1994C20.5977 19.1994 20.922 19.3223 20.9948 19.6411H21.9114C21.7381 18.9202 21.1681 18.5513 20.0836 18.5513C18.9991 18.5513 18.4738 19.0096 18.4738 19.63C18.4738 20.2951 19.0326 20.5076 20.0278 20.5635C20.855 20.6082 21.1122 20.6586 21.1122 20.8989C21.1122 21.1338 20.9112 21.279 20.3074 21.279C19.6869 21.279 19.4074 21.145 19.318 20.8038H18.3452C18.485 21.5752 19.0885 21.9607 20.2735 21.9607C21.3968 21.9607 21.9614 21.5024 21.9614 20.865C21.9618 20.1776 21.4812 19.9762 20.3744 19.9092Z",
      fill: "#1F0038",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M22.3146 19.2605C22.2129 19.2605 22.1286 19.2313 22.0616 19.1731C21.9945 19.115 21.9614 19.0299 21.9614 18.9186V18.902C21.9614 18.8666 21.9653 18.8331 21.9734 18.8019C21.9815 18.7707 21.9926 18.7422 22.0073 18.7164C22.0381 18.6636 22.0797 18.6228 22.1324 18.5939C22.1852 18.565 22.2445 18.5508 22.3107 18.5508C22.3438 18.5508 22.375 18.5542 22.4047 18.5608C22.434 18.5673 22.4625 18.5777 22.4894 18.5912C22.5422 18.6193 22.5845 18.6594 22.6161 18.7118C22.6481 18.7638 22.6639 18.8265 22.6639 18.9001V18.9186C22.6639 18.9552 22.66 18.9894 22.6519 19.0206C22.6438 19.0518 22.6319 19.0799 22.6161 19.1042C22.5853 19.1558 22.5437 19.1947 22.491 19.2209C22.4382 19.2475 22.3797 19.2605 22.3146 19.2605ZM22.3146 19.202C22.3978 19.202 22.4663 19.1774 22.5195 19.1284C22.5726 19.0795 22.5996 19.0083 22.5996 18.9151V18.9039C22.5996 18.8107 22.5722 18.7387 22.5179 18.6879C22.4632 18.637 22.3943 18.6116 22.3111 18.6116C22.2291 18.6116 22.1609 18.6378 22.107 18.6906C22.0531 18.7433 22.0261 18.815 22.0261 18.9059V18.9151C22.0261 19.0071 22.0531 19.078 22.107 19.1277C22.1605 19.177 22.2298 19.202 22.3146 19.202ZM22.318 18.9482H22.2426V19.0826H22.1802V18.7202H22.3254C22.3758 18.7202 22.4116 18.7299 22.4328 18.7495C22.4544 18.7691 22.4652 18.7949 22.4652 18.8269C22.4652 18.8527 22.459 18.8731 22.4467 18.8885C22.4343 18.9039 22.4159 18.9147 22.3916 18.9209C22.4147 18.9259 22.4313 18.9351 22.4413 18.9486C22.4513 18.9621 22.4559 18.9829 22.4559 19.011V19.0641C22.4559 19.068 22.4567 19.0711 22.4578 19.0741C22.459 19.0772 22.4601 19.0799 22.4617 19.0822H22.3974C22.3962 19.0811 22.3951 19.0788 22.3947 19.0757C22.3939 19.0726 22.3939 19.0688 22.3939 19.0638V19.0106C22.3939 18.9871 22.3897 18.9709 22.3812 18.9617C22.372 18.9525 22.3512 18.9482 22.318 18.9482ZM22.318 18.8947C22.35 18.8958 22.3723 18.8908 22.385 18.8789C22.3978 18.8673 22.4043 18.8504 22.4043 18.8284C22.4043 18.81 22.3974 18.7961 22.3839 18.7872C22.3704 18.778 22.3496 18.7734 22.3215 18.7734H22.2426V18.8947H22.318Z",
      fill: "#1F0038",
    }),
    /*#__PURE__*/ React.createElement(
      "defs",
      null,
      /*#__PURE__*/ React.createElement(
        "linearGradient",
        {
          id: "paint0_linear_22854_208",
          x1: "11.548",
          y1: "11.327",
          x2: "8.57598",
          y2: "-3.96277",
          gradientUnits: "userSpaceOnUse",
        },
        /*#__PURE__*/ React.createElement("stop", {
          offset: "0.1411",
          stopColor: "#E50056",
        }),
        /*#__PURE__*/ React.createElement("stop", {
          offset: "0.75",
          stopColor: "#1F0038",
        })
      )
    )
  );
};
Eftpos24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
};
var Eftpos32 = function Eftpos32(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("rect", {
      x: "0.5",
      y: "0.5",
      width: "31",
      height: "23",
      rx: "3.5",
      fill: "white",
      stroke: "#CCCCCC",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M11.4926 5.76061C9.66791 7.22686 8.5 9.47702 8.5 12C8.5 16.4183 12.0817 20 16.5 20C19.4901 20 22.1548 18.3297 23.4643 15.9272C23.5055 15.8513 23.5282 15.7685 23.4742 15.7002C23.3798 15.5808 23.2366 15.6382 23.1091 15.7145C21.9102 16.4357 20.8848 16.7726 19.4266 16.7726C16.2494 16.7726 13.6738 14.5058 13.6738 11.7094C13.6738 9.49373 15.1665 7.56345 17.3735 6.55561C16.7804 5.42454 15.4675 4.96434 14.1795 4.96434C13.1348 4.9644 12.1065 5.26726 11.4926 5.76061Z",
      fill: "url(#paint0_linear_21980_148)",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M23.3717 9.65355C23.3717 12.3109 20.8338 14.4651 17.703 14.4651C17.2474 14.4651 16.014 14.4024 15.1313 13.9916C14.8802 13.8748 14.906 13.7277 15.0785 13.6565C15.4797 13.491 18.6259 12.8873 18.6259 9.65355C18.6259 6.41988 15.2871 4.05552 11.4927 5.76051C12.8634 4.65902 14.6048 3.99992 16.5001 3.99992C20.2154 3.99992 23.3717 6.53113 23.3717 9.65355Z",
      fill: "#E50056",
    }),
    /*#__PURE__*/ React.createElement(
      "defs",
      null,
      /*#__PURE__*/ React.createElement(
        "linearGradient",
        {
          id: "paint0_linear_21980_148",
          x1: "16.0728",
          y1: "14.6368",
          x2: "13.0114",
          y2: "-1.11275",
          gradientUnits: "userSpaceOnUse",
        },
        /*#__PURE__*/ React.createElement("stop", {
          stopColor: "#E50056",
        }),
        /*#__PURE__*/ React.createElement("stop", {
          offset: "0.141092",
          stopColor: "#E50056",
        }),
        /*#__PURE__*/ React.createElement("stop", {
          offset: "0.75",
          stopColor: "#1F0038",
        }),
        /*#__PURE__*/ React.createElement("stop", {
          offset: "1",
          stopColor: "#1F0038",
        })
      )
    )
  );
};
Eftpos32.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Eftpos24,
  32: Eftpos32,
};
export function Eftpos(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Eftpos' icon. Please use one of the available sizes: '24', '32'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
